import { AppError, AppErrorCode, Context, CoreDict, TranslationService, runIfDefined } from '../../../common'
import { PermissionDescriptor, getPermissionDescriptorByName } from './permissions'

export type RequestedPermission = string | string[] | PermissionDescriptor | PermissionDescriptor[]

export function getPermissionNames(permission: RequestedPermission): string[] {
  if (typeof permission === 'string') {
    return [permission]
  } else if (permission instanceof Array) {
    return permission.map(it => {
      if (typeof it === 'string') return it
      else return it.name
    })
  } else {
    return [permission.name]
  }
}

export interface PermissionsService {
  hasPermission(ctx: Context, permission: RequestedPermission): Promise<boolean>
  checkPermission(ctx: Context, permission: RequestedPermission): Promise<void>
}

export async function checkPermissionImpl(
  ctx: Context,
  hasPermission: (ctx: Context, permission: RequestedPermission) => Promise<boolean>,
  translationService: TranslationService<CoreDict>,
  permission: RequestedPermission,
) {
  const permissionNames = getPermissionNames(permission)
  const allowed = await hasPermission(ctx, permissionNames)
  if (!allowed) {
    throw new AppError(
      AppErrorCode.ACCESS_DENIED,
      `<b2363957> ${translationService.translate(
        ctx.langCode,
        d => d.permissions.insufficientUserPermissionsError,
        permissionNames
          .map(
            perm =>
              runIfDefined(
                getPermissionDescriptorByName(perm),
                d => `${translationService.tr(ctx, d.description)} (${d.name})`,
              ) ?? perm,
          )
          .join(', '),
      )}`,
    )
  }
}
